/* eslint-disable */
import { OfferType } from '../models/replacement.offer.model';

export const mockSelected = {
  item_code: 'AW',
  warranty: 24,
  manuf_code: 'BOSC',
  make: 'BOSCH',
  model: 'WAW32560GB',
  colour: 'White',
  offer_type: OfferType.REPLACEMENT,
  display_order: 12,
  upgrade_fee: 495,
  rrp: 0,
  article_id: 2147229481,
  appliance_category: 'Washing Machine',
  short_description: 'BOSCH WAW32560GB Washing Machine',
  long_description: 'BOSCH WAW32560GB Washing Machine White A+++ 9 1600',
  selected: false,
  supplier_name: 'RGB',
  cat_num: 'WAW32560GB',
  supplier_id: 6684,
  services: [],
  summary_specs: [
    'EcoSilence Drive: extremely energy-efficient and quiet in operation',
    'Consumption indication: easy operation and indication of energy and water consumption',
    'AutoStain: removes the four most common stains',
    'Energy efficiency class A+++: more efficient',
    'DrumClean with reminder function: program for cleaning and maintaining the drum',
    'Cottons 60 Eco and Cottons 40 Eco: the most efficient programs in terms of combined energy and water consumption',
    'VarioPerfect: speed or energy efficiency with perfect wash performance every time',
    'ActiveWater: water management system',
    'AntiVibration design - for more stability and quietness',
    'Consumption indication: information about energy and water consumption',
    'Large LED display for program status indication, temperature selection, spin speed, remaining time',
    '24 h end time delay, stain selection and consumption indication',
    'Control dial with integrated On/Off mode',
    'Reload facility',
    'Drum interior light',
    'Self-cleaning detergent drawer',
    'WaveDrum: gentle and efficient washing',
    'Sound insulation by additional noise reduction material',
    'Child lock',
    'Buzzer',
  ],
  images: [
    {
      text: 'Right-angle',
      url: 'https://cdn.cnetcontent.com/fe/eb/feebc34f-1636-4828-bde0-b36269913563.jpg',
    },
    {
      text: 'Right side',
      url: 'https://cdn.cnetcontent.com/de/65/de657192-67af-4087-aaf7-a7742b749e36.jpg',
    },
    {
      text: 'Close-up',
      url: 'https://cdn.cnetcontent.com/df/62/df6292ff-5625-4ee9-98d9-f220c05f4f0a.jpg',
    },
  ],
  compare_specs: [
    {
      name: 'Bluetooth',
      value: 'No',
    },
    {
      name: 'Construction',
      value: 'Freestanding',
    },
    {
      name: 'Delay Timer',
      value: 'Yes',
    },
    {
      name: 'Depth',
      value: '590',
    },
    {
      name: 'Drying Function',
      value: 'No',
    },
    {
      name: 'Energy Efficiency',
      value: 'A+++',
    },
    {
      name: 'Height',
      value: '845',
    },
    {
      name: 'Loading',
      value: 'Front Loader',
    },
    {
      name: 'Make',
      value: 'Bosch',
    },
    {
      name: 'ReleaseDate',
      value: 'Jun  1 2014 12:00AM',
    },
    {
      name: 'Spin Efficiency',
      value: 'A',
    },
    {
      name: 'Spin Speed',
      value: '1600',
    },
    {
      name: 'Type',
      value: 'Washing machine',
    },
    {
      name: 'Wash Capacity',
      value: '9',
    },
    {
      name: 'Wash Efficiency',
      value: 'A',
    },
    {
      name: 'Width',
      value: '600',
    },
    {
      name: 'WiFi',
      value: 'No',
    },
  ],
  detailed_specs: [
    {
      name: 'Product Description',
      value:
        'Bosch Serie | 8 Logixx WAW32560GB washing machine - front loading - freestanding - white',
    },
    {
      name: 'Product Type',
      value: 'Washing machine - front loading',
    },
    {
      name: 'Energy Class',
      value: 'Class A+++ -30%',
    },
    {
      name: 'Loading Capacity',
      value: '9 kg',
    },
    {
      name: 'Energy Consumption per Year',
      value: '152 kWh',
    },
    {
      name: 'Water Consumption per Year',
      value: '11220 liters',
    },
    {
      name: 'Spin Class',
      value: 'Class A',
    },
    {
      name: 'Spin Speed',
      value: 'Variable - 1552 rpm (max)',
    },
    {
      name: 'Residual Moisture',
      value: '44%',
    },
    {
      name: 'Noise Level (Washing)',
      value: '47 dB',
    },
    {
      name: 'Noise Level (Spinning)',
      value: '73 dB',
    },
    {
      name: 'Maximum Noise Level',
      value: '73 dB',
    },
    {
      name: 'Form Factor',
      value: 'Freestanding (can be integrated)',
    },
    {
      name: 'Color',
      value: 'White',
    },
    {
      name: 'Washer Drum Capacity',
      value: '65 liters',
    },
    {
      name: 'Washing Efficiency',
      value: 'Class A',
    },
    {
      name: 'Safety Features',
      value: 'Child security, water protection system',
    },
    {
      name: 'Voltage',
      value: '220 - 240 V / 50 Hz',
    },
    {
      name: 'Plug Type',
      value: 'British',
    },
    {
      name: 'Dimensions (WxDxH)',
      value: '60 cm x 59 cm x 84.5 cm',
    },
    {
      name: 'Weight',
      value: '80 kg',
    },
    {
      name: 'Manufacturer Warranty',
      value: '2 years',
    },
    {
      name: 'Warranty Details',
      value: '10-year motor warranty',
    },
    {
      name: 'Standard Washing Program',
      value: 'Cotton + EcoPerfect',
    },
    {
      name: 'Duration of the Left-on Mode',
      value: '15 min',
    },
    {
      name: 'Installation Type',
      value: 'Built under',
    },
    {
      name: 'Door Opening Angle',
      value: '171 degrees',
    },
    {
      name: 'Door Opening Diameter',
      value: '32 cm',
    },
    {
      name: 'Vibration Reduction',
      value: 'Yes',
    },
    {
      name: 'Program Time Details',
      value: '275 min - washing - full load - 60 °C',
    },
    {
      name: 'Exterior Color',
      value: 'White',
    },
    {
      name: 'Drum Material',
      value: 'Stainless steel',
    },
    {
      name: 'Drum Features',
      value: 'waveDrum, drum light',
    },
    {
      name: 'Timer Settings Features',
      value:
        'Start timer delay, program ending audible signal, countdown timer',
    },
    {
      name: 'Maximum Start Timer Delay',
      value: '24 hours',
    },
    {
      name: 'Indicators',
      value: `End of cycle, time remaining indicator,
        water temperature indicator, wash progress
        indicator, drum cleaning indicator, consumption indicator`,
    },
    {
      name: 'Type',
      value: 'LED display',
    },
    {
      name: 'Special Programs & Options',
      value: `Pre-wash, wool, cold wash, cotton, hand wash,
         easy care, SpeedPerfect, shirts, sportswear, duvet,
         drain, mixed load, skip spin, Easy Iron, rinse + spin,
         ecoPerfect, Night Wash, Super Quick 15, delicate 30°, reduced
         ironing, pause option, Allergy Plus, auto stains removal, drum
         cleaning, Aquaplus, varioPerfect`,
    },
    {
      name: 'Interior Light',
      value: 'Yes',
    },
    {
      name: 'Features',
      value: `EcoSilence Drive motor, VarioPerfect option,
        ActiveWater system, Aqua Plus, autoStain Removal System
        (ASR), reload facility, self-cleaning detergent drawer,
        AntiVibration Design, variable temperature, balance control,
        foam control, DrumClean with reminder function`,
    },
    {
      name: 'Exterior Features',
      value: 'White control panel, left hinged, white satin aluminum door rim',
    },
    {
      name: 'Wheels & Leveling',
      value: 'Adjustable feet',
    },
    {
      name: 'Compliant Standards',
      value: 'VDE, Directive 1061/2010/EU',
    },
    {
      name: 'Energy Consumption Details',
      value: '0.92 kWh - washing - full load - 60 °C',
    },
    {
      name: 'Max Power Consumption',
      value: '2300 W',
    },
    {
      name: 'Power Consumption Off-Mode',
      value: '0.12 W',
    },
    {
      name: 'Power Consumption Left-on Mode',
      value: '0.43 W',
    },
    {
      name: 'Cord Length',
      value: '1.75 m',
    },
    {
      name: 'Width',
      value: '60 cm',
    },
    {
      name: 'Depth',
      value: '59 cm',
    },
    {
      name: 'Height',
      value: '84.5 cm',
    },
    {
      name: 'Weight (Shipping)',
      value: '81 kg',
    },
    {
      name: 'Warranty',
      value: '2 years',
    },
  ],
};
